/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  authenticated(state) {
    return (state.token && state.user) ? true : false;
  },
  user(state) {
    return state.user;
  },
  address(state) {
    return state.address;
  }
};
